<template>
    <section class="side-section bg-white mt-2 p-4">
        <h5>Filtre</h5>
        <div class="side-row">
            <h6>Aktarmalar (Gidiş)</h6>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="direct-fly" @click="ucusTipi = 'Direkt'">
                <label class="custom-control-label" for="direct-fly">Direkt uçuşlar</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="one-fly">
                <label class="custom-control-label" for="one-fly">1 Aktarmalı Uçuşlar</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="two-fly">
                <label class="custom-control-label" for="two-fly">2+ Aktarmalı Uçuşlar</label>
            </div>
        </div>

        <div class="side-row">
            <h6>Aktarmalar (Dönüş)</h6>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="direct-return-fly">
                <label class="custom-control-label" for="direct-return-fly">Direkt uçuşlar</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="one-return-fly">
                <label class="custom-control-label" for="one-return-fly">1 Aktarmalı Uçuşlar</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="two-return-fly">
                <label class="custom-control-label" for="two-return-fly">2+ Aktarmalı Uçuşlar</label>
            </div>
        </div>

        <div class="side-row">
            <h6>Uçuş Sınıfları</h6>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="busines-fly">
                <label class="custom-control-label" for="busines-fly">Business</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="economy-fly">
                <label class="custom-control-label" for="economy-fly">Ekonomi</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="promotion-fly">
                <label class="custom-control-label" for="promotion-fly">Promosyon</label>
            </div>
        </div>
        <div class="side-row">
            <h6>Gidiş Kalkış & Varış Saatleri</h6>
            <p class="text-muted">Gidiş Saat : <span class="color-blue"><b>{{gidisKalkis[0]}}:00 - {{gidisKalkis[1]}}:00</b></span></p>
            <vue-slider v-model="gidisKalkis" :min="0"
                        :max="24"
                        :interval="1" :enable-cross="false"></vue-slider>
            <p></p>
            <p class="text-muted">Gidiş Varış : <span class="color-blue"><b>{{gidisVaris[0]}}:00 - {{gidisVaris[1]}}:00</b></span></p>
            <vue-slider v-model="gidisVaris" :min="0"
                        :max="24"
                        :interval="1" :enable-cross="false"></vue-slider>
        </div>
        <div class="side-row">
            <h6>Dönüş Kalkış & Varış Saatleri</h6>
            <p class="text-muted">Gidiş Saat : <span class="color-blue"><b>{{donusKalkis[0]}}:00 - {{donusKalkis[1]}}:00</b></span></p>
            <vue-slider v-model="donusKalkis" :min="0"
                        :max="24"
                        :interval="1" :enable-cross="false"></vue-slider>
            <p></p>
            <p class="text-muted">Gidiş Varış : <span class="color-blue"><b>{{donusVaris[0]}}:00 - {{donusVaris[1]}}:00</b></span></p>
            <vue-slider v-model="donusVaris" :min="0"
                        :max="24"
                        :interval="1" :enable-cross="false"></vue-slider>
        </div>
        <div class="side-row">
            <h6>Havayolları</h6>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="anadolu-fly">
                <label class="custom-control-label" for="anadolu-fly">Anadolu Jet</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="thy-fly">
                <label class="custom-control-label" for="thy-fly">Türk Hava Yolları</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="pegasus-fly">
                <label class="custom-control-label" for="pegasus-fly">Pegasus</label>
            </div>
        </div>
    </section>
</template>

<script>
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css'
    export default {
        name: "sideBar",
        components: {
            VueSlider
        },
        data: function () {
            return {
                gidisKalkis: [0, 24],
                gidisVaris: [0, 24],
                donusKalkis: [0, 24],
                donusVaris: [0, 24],
                ucusTipi:"all",
            }
        }
    }
</script>

<style scoped>

</style>